import * as axios from 'axios';

const { VUE_APP_API_URL } = process.env || {};
export const getRegions = (token) => axios.get(`${VUE_APP_API_URL}/api/v1/admin/retail-lab/regions`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});

export const createRetailLabRegion = (token, body) => axios.post(`${VUE_APP_API_URL}/api/v1/admin/retailLabRegions`, body, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});

export const archiveRetailLabRegion = (token, id, value) => axios.patch(
  `${VUE_APP_API_URL}/api/v1/admin/retailLabRegions/${id}`,
  { archived: value },
  {
    headers: {
      Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
    },
  },
);
